import styles from './styles/index.module.scss';

type Props = {
  name: string,
  required?: boolean,
  value: string,
  onInput: React.FormEventHandler<HTMLTextAreaElement>,
  placeholder?: string,
};

export default function Textarea({ name, required, value, onInput, placeholder }: Props ) {

  return (
    <>
      <textarea className={styles.textarea} name={name} required={required} value={value} onInput={onInput} placeholder={placeholder} />
    </>

  );
}